import { useEffect, useMemo, memo } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardCount } from "../../Redux/Actions/dashboardActions";
import DashboardGraph from "./dashboardGraph";
import GraphComponent from "./graphComponent";
import { useNavigate } from "react-router-dom";
import "./viewDashboard.css";

import waveUsers      from "./vector.png";
import waveBuilders   from "./vector3.png";
import waveProjects   from "./vector1.png";
import waveProperties from "./vector4.png";
import waveBookings   from "./vector7.png";
import waveMeetings   from "./vector6.png";
import waveCoupons    from "./vector5.png";
import wavePayments   from "./vector2.png";


const Card = memo(({ label, value, cls, route, wave, onNavigate }) => (
  <div className={`vd-stat-card ${cls}`} onClick={() => onNavigate(route)}>
    <p className="vd-card-label">{label}</p>
    <h3 className="vd-card-value">{value ?? "0"}</h3>
    <img src={wave} alt="" className="vd-card-wave" />
  </div>
));


const DonutSection = memo(({ donutData, donutOptions, donutColors, donutValues, totalDonut }) => (
  <div className="vd-donut-section">
    <p className="vd-donut-title">Admin Stats</p>
    <div className="vd-donut-inner">
      <div className="vd-donut-canvas-wrap">
        <GraphComponent
          type="doughnut"
          data={donutData}
          options={donutOptions}
          graphHeading=""
        />
        <div className="vd-donut-center">
          <span className="vd-donut-center-total">{totalDonut.toLocaleString()}</span>
          <span className="vd-donut-center-label">Total</span>
        </div>
      </div>
      <ul className="vd-legend-list">
        {["Bookings","Properties","Projects","Meetings","Coupons","Users","Events","Builders"].map((name, i) => (
          <li key={i} className="vd-legend-item">
            <span className="vd-legend-dot" style={{ background: donutColors[i] }} />
            <span className="vd-legend-val">{donutValues[i].toLocaleString()}</span>
            <span className="vd-legend-name">{name}</span>
          </li>
        ))}
      </ul>
    </div>
  </div>
));

const GraphSection = memo(() => (
  <div className="vd-bar-section">
    <DashboardGraph />
  </div>
));

const ViewDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getDashboardCount());
  }, [dispatch]);

  const { dashboardCount } = useSelector((state) => state.dashboard || {});
  const d = dashboardCount?.data;

  const donutColors = useMemo(() => [
    "#9966FF", "#4BC0C0", "#FFCE56", "#FF9F40",
    "#00C49F", "#FF6384", "#FF6F61", "#36A2EB",
  ], []);

  const donutValues = useMemo(() => [
    d?.booking_count  || 0,
    d?.property_count || 0,
    d?.projects_count || 0,
    d?.meetings_count || 0,
    d?.coupons_count  || 0,
    d?.users_count    || 0,
    d?.event_count    || 0,
    d?.builders_count || 0,
  ], [d]);

  const totalDonut = useMemo(
    () => donutValues.reduce((a, b) => a + b, 0),
    [donutValues]
  );

  const donutData = useMemo(() => ({
    labels: ["Bookings","Properties","Projects","Meetings","Coupons","Users","Events","Builders"],
    datasets: [{
      label: "Dashboard Stats",
      data: donutValues,
      backgroundColor: donutColors,
      borderWidth: 0,
      hoverOffset: 6,
    }],
  }), [donutValues, donutColors]);

  const donutOptions = useMemo(() => ({
    cutout: "65%",
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      datalabels: { display: false },
    },
  }), []);

  return (
    <MainLayout>
      <div className="vd-wrapper">

        <div className="vd-row1">
          <Card label="Users"      value={d?.users_count}    cls="vd-card--users"      route="/manage_users"      wave={waveUsers}      onNavigate={navigate} />
          <Card label="Builders"   value={d?.builders_count}  cls="vd-card--builders"   route="/builders"          wave={waveBuilders}   onNavigate={navigate} />
          <Card label="Projects"   value={d?.projects_count}  cls="vd-card--projects"   route="/manage_projects"   wave={waveProjects}   onNavigate={navigate} />
          <Card label="Properties" value={d?.property_count}  cls="vd-card--properties" route="/manage_properties" wave={waveProperties} onNavigate={navigate} />
        </div>

        <div className="vd-bottom-grid">
          <div className="vd-bottom-cards">
            <Card label="Bookings" value={d?.booking_count}  cls="vd-card--bookings" route="/bookings"       wave={waveBookings} onNavigate={navigate} />
            <Card label="Meetings" value={d?.meetings_count} cls="vd-card--meetings" route="/meeting"        wave={waveMeetings} onNavigate={navigate} />
            <Card label="Coupons"  value={d?.coupons_count}  cls="vd-card--coupons"  route="/dealsAndOffers" wave={waveCoupons}  onNavigate={navigate} />
            <Card label="Payments" value={d?.payment_count}  cls="vd-card--payments" route="/payments"       wave={wavePayments} onNavigate={navigate} />
          </div>

          <DonutSection
            donutData={donutData}
            donutOptions={donutOptions}
            donutColors={donutColors}
            donutValues={donutValues}
            totalDonut={totalDonut}
          />
        </div>

        <GraphSection />

      </div>
    </MainLayout>
  );
};

export default ViewDashboard;